// utils
import React from "react";
import { Row, Col } from "react-bootstrap";

// files
import square_divelit_grey_50 from "../../../../files/icons/rency/square_divelit_grey_50.svg";
import square_divelit_grey_60 from "../../../../files/icons/rency/square_divelit_grey_60.svg";
import square_divelit_grey_70 from "../../../../files/icons/rency/square_divelit_grey_70.svg";
import square_black from "../../../../files/icons/rency/square_black.svg";

// squares used as bullets of grant data - colour marks the order (same as OUR-WORK tiles)
const SQUARES = [square_divelit_grey_50, square_divelit_grey_60, square_divelit_grey_70, square_black];

export type GrantInfoItem = {label: string, value: string};

/**
 * GrantInfo component
 * key grant data (operational programme, call, registration number, beneficiary ...) with hatched squares
 * shared by grant tile (GRANTS page) and grant detail page
 * @returns HTML code of grant data grid
 */
export default function GrantInfo(props: {info: GrantInfoItem[]}) {
    return (
        <Row className="gy-3 gy-lg-4">
            {props.info.map((item, index) =>
                <Col xs={12} sm={12} lg={6} key={index}>
                    <div className="d-flex flex-row align-items-start style-zoom-1">
                        <img src={SQUARES[index % SQUARES.length]} className="d-inline-block home-experts-img-1 w-fit-content grants-info-square" alt="" aria-hidden="true"/>
                        <div className="ms-3">
                            <p className="paragraph-medium font-divelit-grey-50 grants-info-label">
                                {item.label}
                            </p>
                            <p className="paragraph-small font-black mb-0">
                                {item.value}
                            </p>
                        </div>
                    </div>
                </Col>
            )}
        </Row>
    );
}
